module.exports = __webpack_public_path__ + "img/970203809_1200.7e0b384e.jpg";